import './cmspage.less'

import {Icon, Page} from '@codeurs/front'
import m from 'mithril'
import {Country, Entry} from 'types'
import {AuthorType, LinkType} from 'types/types'
import {ContactType} from './pages/contact'
import {BlockType} from './partials/blocks'

export default class CMSPage<Data = {}> extends Page<{
	data: {
		links: Record<string, {title: string; url: string}>
		menu: Array<LinkType>
		side_menu: Array<LinkType>
		lists: {
			countries: Array<Country>
			tags: {[id: string]: string}
			sectors: {[id: string]: string}
			policies: {
				[id: string]: {
					name: string
					areas: [] | {[id: string]: string}
				}
			}
			authors: Array<Entry & AuthorType>
		}
		title: string
		channel: string
		id: string
		url: string
		path: string
		contact: ContactType
		latitude: number
		longitude: number
		blocks: Array<BlockType>
	} & Data
}> {
	static render(attrs) {
		return m('.cmspage', [this.viewCmsLink(attrs), m(this, attrs)])
	}

	static viewCmsLink(attrs) {
		const {is_admin, id} = attrs.data

		if (!is_admin) return
		const href = `${window.location.protocol}//${
			window.location.hostname
		}/admin/project/smeunited/en/entry/${id}`
		return m('a.cmspage-cmslink',
			{href, target: '_blank'},
			m(Icon, {icon: 'edit'}),
			m('span.cmspage-cmslink-copy', ' Edit in CMS')
		)
	}
}
